import {
    collection,
    getDocs,
    query,
    orderBy,
    onSnapshot,
    db
} from '../firebase';

/**
 * DealService
 * Handles operations for categories subcollection
 */
class DealService {


    /**
     * Subscribe to categories updates in real-time
     * @param {string} oscarsPartyId - The Oscar party document ID
     * @param {Function} callback - Function to call when categories data changes
     * @returns {Function} Unsubscribe function
     */
    subscribeToDeals(callback) {
        try {
            const dealsRef = collection(db, 'players_punch');
            const q = query(dealsRef);

            const unsubscribe = onSnapshot(
                q,
                (snapshot) => {
                    const deals = [];
                    snapshot.forEach((docSnapshot) => {
                        deals.push({
                            id: docSnapshot.id,
                            ...docSnapshot.data()
                        });
                    });
                    callback(deals);
                },
                (error) => {
                    console.error('Error listening to deals:', error);
                    callback([]);
                }
            );

            return unsubscribe;
        } catch (error) {
            console.error('Error setting up deals subscription:', error);
            callback([]);
            return () => { }; // Return no-op unsubscribe function
        }
    }
}

// Export singleton instance
export default new DealService();
